// i18n
import './locales/i18n';

// lazy image
import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { HelmetProvider } from 'react-helmet-async';
import { Provider as ReduxProvider } from 'react-redux';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { store } from './redux/store';
import { SettingsProvider } from './contexts/SettingsContext';
import { AuthProvider } from './contexts/JWTContext';
import { RootErrorBoundary } from './components/RootErrorBoundary';
import App from './App';
import reportWebVitals from './reportWebVitals';

// highlight — deferred; TipTap lives in lazy routes so window.hljs is not needed at startup
import('./common/highlight');

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);

root.render(
  <RootErrorBoundary>
    <HelmetProvider>
      <ReduxProvider store={store}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <BrowserRouter>
            <AuthProvider>
              <SettingsProvider>
                <App />
              </SettingsProvider>
            </AuthProvider>
          </BrowserRouter>
        </LocalizationProvider>
      </ReduxProvider>
    </HelmetProvider>
  </RootErrorBoundary>
);

// Sentry lazy-loaded after first render — keeps it out of the cold-start critical path
if (import.meta.env.PROD) {
  import('./common/sentryInit').then((m) => m.initSentry());
}

reportWebVitals();
